const FacebookCircle = () => (
  <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1926_283)">
      <path
        d="M23.5 12.4858C23.5 6.13453 18.3513 0.985804 12 0.985804C5.64872 0.985804 0.5 6.13453 0.5 12.4858C0.5 18.2258 4.70538 22.9834 10.2031 23.8461V15.81H7.2832V12.4858H10.2031V9.95221C10.2031 7.07002 11.92 5.47799 14.5468 5.47799C15.805 5.47799 17.1211 5.7026 17.1211 5.7026V8.53268H15.671C14.2424 8.53268 13.7969 9.41914 13.7969 10.3286V12.4858H16.9863L16.4765 15.81H13.7969V23.8461C19.2946 22.9834 23.5 18.2258 23.5 12.4858Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1926_283">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.415955)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default FacebookCircle
